import { useAuth } from "@/features/auth/useAuth";
import { H2 } from "../../components/ui/typography";

import DashboardNROTabs from "@/features/dashboard/DashboardNROTabs";

export function Dashboard() {
  const auth = useAuth();
  const user = auth.getUser();
  if (!user) {
    console.error("User is not found.");
    return null;
  }

  return (
    <>
      <H2>
        Welcome {user.firstName} {user.lastName}
      </H2>
      <DashboardNROTabs />
    </>
  );
}
